import React from 'react';
import { createRoot } from 'react-dom/client'; // ✅ updated import

import VariantPicker from './variantPicker/VariantPicker';
import VariantPrice from './variantPicker/VariantPrice';
import variantPickerStore from '../stores/variantPicker';

import { onAddToCheckoutSuccess, onAddToCheckoutError } from './checkout';

export default $(document).ready(() => {
  const variantPickerContainer = document.getElementById('variant-picker');
  const variantPriceContainer = document.getElementById('variant-price-component');

  if (variantPickerContainer) {
    const variantPickerData = JSON.parse(variantPickerContainer.dataset.variantPickerData);
    console.log("variant-picker:variantPickerContainer");

    const root = createRoot(variantPickerContainer); // ✅ create root
    root.render(
      <VariantPicker
        onAddToCheckoutError={onAddToCheckoutError}
        onAddToCheckoutSuccess={onAddToCheckoutSuccess}
        store={variantPickerStore}
        url={variantPickerContainer.dataset.action}
        variantAttributes={variantPickerData.variantAttributes}
        variants={variantPickerData.variants}
      />
    );

    if (variantPriceContainer) {
      console.log("variant-picker:variantPriceContainer");

      const priceRoot = createRoot(variantPriceContainer); // ✅ second root
      priceRoot.render(
        <VariantPrice
          availability={variantPickerData.availability}
          priceDisplay={variantPickerData.priceDisplay}
          store={variantPickerStore}
        />
      );
    }
  }
});
